import { ReactElement } from 'react';

import { ITab } from 'coreOld/types';

import TabsNavigation from './TabsNavigation';

interface IProps {
  tabs: ITab[];
  onClick: (tab: ITab) => void;
  children?: ReactElement | ReactElement[];
}

const TabsView = ({ tabs, onClick, children }: IProps) => {
  return (
    <>
      <TabsNavigation tabs={tabs} onClick={onClick} />

      {children}
    </>
  );
};

export default TabsView;
